import { CardsSection } from 'components/layout/Section/CardsSection';
import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { legalEntityFinancialsInputsConfig } from 'features/new-actor/form/inputs-config/optim/legalEntityFinancialsInputsConfig';
import { LegalEntityFinancialsFormValues } from 'features/new-actor/types/optim/legalEntityFinancialsFormValues';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { Calculator } from 'lucide-react';

// Accounting data of the parent company, bound to `financials.*` in the legal entity form values.
export const LegalEntityFinancialsSection: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.ActorForm]);

  const renderField = (fieldName: keyof LegalEntityFinancialsFormValues) => (
    <InputFactory config={legalEntityFinancialsInputsConfig} fieldName={fieldName} />
  );

  return (
    // Same section header as « Contacts » just above: icon and title in the primary colour.
    <CardsSection
      icon={<Calculator className="h-8 w-8 text-primary" />}
      title={t('ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.TITLE')}
    >
      {/* Two per row, like the rest of the legal entity form: a third is too narrow for the date label. */}
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-3">{renderField('revenue')}</div>
        <div className="col-span-3">{renderField('employeesCount')}</div>
        <div className="col-span-3">{renderField('fiscalYearEnd')}</div>
      </div>
    </CardsSection>
  );
};
